import className from 'classnames/bind';
import styles from './ContentWrapper.module.scss';

let cx = className.bind(styles);

/**
 * Renders WordPress post content as HTML.
 * Content is from WordPress admin only (trusted source; see docs/SECURITY.md).
 * Do not pass unsanitized user input here.
 */
export default function ContentWrapper({ content, children, className }) {
  return (
    <article className={cx(['component', className])}>
      <div dangerouslySetInnerHTML={{ __html: content ?? '' }} />
      {children}
    </article>
  );
}
